
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 511 511","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M133.1 394.6c-34.1 0-64.4-21.8-75.4-54.3l-.7-2.4c-2.6-8.6-3.7-15.8-3.7-23.1V169.5L1.6 342c-6.6 25.4 8.5 51.7 33.9 58.7l329.2 88.2c4.1 1.1 8.2 1.6 12.3 1.6 21.2 0 40.6-14.1 46-34.8l19.2-61H133.1zM191.6 171c23.5 0 42.6-19.1 42.6-42.6s-19.1-42.6-42.6-42.6-42.6 19.1-42.6 42.6 19.1 42.6 42.6 42.6z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M457.8 21.9H138.4c-29.3 0-53.2 23.9-53.2 53.2v234.2c0 29.3 23.9 53.2 53.2 53.2h319.4c29.3 0 53.2-23.9 53.2-53.2V75.2c0-29.4-23.9-53.3-53.2-53.3zM138.4 64.5h319.4c5.9 0 10.6 4.8 10.6 10.6v151.2l-67.3-78.5c-7.1-8.4-17.5-12.8-28.6-13.1-11 .1-21.4 5-28.4 13.4L265 243l-25.8-25.7c-14.6-14.6-38.3-14.6-52.8 0L127.6 276V75c.1-5.7 4.9-10.5 10.8-10.5z"}})])
          )
        }
      }
    